import { useContext } from 'react';
import { useWidgetCRUDActions } from '@mm/state/actions/WidgetCRUDActions';
import ButtonModel, { PageButtonConfig } from '@mm/state/model/ButtonModel';
import { PathGraphContext } from '../../widgets/common/PathGraph/PathGraph';
import { useCommonWidgetHandlers } from './use-common-widget-handlers';
import { usePageCRUDActions } from '@mm/state/actions/PageCRUDActions';
import { useSelector } from 'react-redux';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import QuickQuestionWidget from '../../../editor/features/build/requestModels/widgets/QuickQuestionWidget';
import { WidgetTypes } from '@mm/state/model/WidgetModel';

export const useSmsOptinWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();
  const widgetCRUDActions = useWidgetCRUDActions();
  const pageCRUDActions = usePageCRUDActions();

  const chatbotId = useSelector(activeChatbotIdSelector);

  const { addDialogueWidgetsToGraph } = useContext(PathGraphContext);

  const addNew = async (dialogueId: number, sortOrder: number) => {
    const newWidget = QuickQuestionWidget.make(
      WidgetTypes.SMS_OPT_IN_V2,
      dialogueId,
      sortOrder,
    );

    const createdWidget = await commonWidgetHandlers.create(
      newWidget,
      dialogueId,
      sortOrder,
    );

    if (createdWidget) {
      await pageCRUDActions.retrieveAll(chatbotId);
      addDialogueWidgetsToGraph?.([createdWidget]);
      const widgetButtons = (createdWidget.buttons as ButtonModel[]) || [];
      const newlyAddedDialogueIds = widgetButtons
        .map(b => (b.config as PageButtonConfig).pageId)
        .filter(id => id);

      await Promise.all(
        newlyAddedDialogueIds.map(id =>
          widgetCRUDActions.retrieveAll(id, true),
        ),
      );
    }
    return createdWidget;
  };

  return {
    delete: commonWidgetHandlers.delete,
    addNew,
  };
};
